<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">订单管理</div>
        <div class="page-subtitle">交易订单查询与异常处理</div>
      </div>
      <!-- <el-button type="primary" plain>导出订单</el-button> -->
    </div>
    <el-card>
      <div class="order-summary">
        <div class="summary-item">
          <div class="summary-label">总订单数</div>
          <div class="summary-value">{{ totalCount }}</div>
        </div>
        <div class="summary-group">
          <div class="summary-label">支付状态</div>
          <div class="summary-tags">
            <el-tag v-for="item in statusStats" :key="item.label" size="small">{{ item.label }} {{ item.value
              }}</el-tag>
          </div>
        </div>
        <div class="summary-group">
          <div class="summary-label">支付方式</div>
          <div class="summary-tags">
            <el-tag v-for="item in payTypeStats" :key="item.label" size="small" type="info">{{ item.label }} {{
              item.value }}</el-tag>
          </div>
        </div>
      </div>
      <div class="order-summary order-summary-money">
        <div class="summary-item">
          <div class="summary-label">金额统计</div>
          <div class="summary-value">明细展示</div>

          <!-- {{ totalMoney }} -->
        </div>
        <div class="summary-group">
          <div class="summary-label">状态金额</div>
          <div class="summary-tags">
            <el-tag v-for="item in statusMoneyStats" :key="item.label" size="small">{{ item.label }} {{ item.value
              }}</el-tag>
          </div>
        </div>
        <div class="summary-group">
          <div class="summary-label">方式金额</div>
          <div class="summary-tags">
            <el-tag v-for="item in payTypeMoneyStats" :key="item.label" size="small" type="info">{{ item.label }} {{
              item.value }}</el-tag>
          </div>
        </div>
      </div>

      <el-form class="table-filters" inline size="small">
        <el-form-item label="时间范围">
          <el-date-picker v-model="filters.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="商户">
          <el-select v-model="filters.mid" placeholder="选择商户" clearable @change="handleMerchantChange">
            <el-option
              v-for="merchant in other.merchants"
              :key="merchant.id"
              :label="merchant.name+'('+merchant.id+')'"
              :value="merchant.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="子商编">
          <el-select v-model="filters.subMerchantId" placeholder="选择子商编" clearable>
            <el-option
              v-for="subMerchant in getSubMerchants()"
              :key="subMerchant.id"
              :label="`${subMerchant.subMerchantId} (${subMerchant.channelFullName})`"
              :value="subMerchant.subMerchantId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="订单ID">
          <el-input v-model="filters.orderId" placeholder="订单ID" clearable />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="filters.keyword" placeholder="商户单号/三方单号" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="待付款" value="0" />
            <el-option label="已付款" value="1" />
            <el-option label="退款中" value="2" />
            <el-option label="已退款" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="filters.paymentType" placeholder="全部" clearable>
            <el-option label="微信支付" value="wechat" />
            <el-option label="支付宝支付" value="alipay" />
            <el-option label="微信扫码支付" value="wechat_scan" />
             <el-option label="微信公众号支付" value="wechat_jsapi" />
            <el-option label="支付宝扫码支付" value="alipay_scan" />

          </el-select>
        </el-form-item>
        <el-form-item label="用户IP">
          <el-input v-model="filters.user_ip" placeholder="用户IP" clearable />
        </el-form-item>
        <el-form-item label="下单IP">
          <el-input v-model="filters.terminalIp" placeholder="下单IP" clearable />
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <div>
        <el-button type="danger" size="mini" :disabled="!selectedIds.length" @click="confirmDelete">删除已选</el-button>
      </div>
      <el-table :data="orders" stripe @sort-change="handleSortChange" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" />
        <!-- ID -->
        <el-table-column prop="id" label="ID" min-width="80" sortable="custom" align="center" />
        
        <!-- 商户信息 -->
        <el-table-column label="商户信息" min-width="140" align="left">
          <template slot-scope="scope">
            <div class="merchant-info">
              <!-- <div class="merchant-id">商户ID: {{ scope.row.admin_id }}</div> -->
              <div class="merchant-code">编码: {{ scope.row.merchantCode }}</div>
              <div class="sub-merchant">子商编: {{ scope.row.subMerchantId }}</div>
            </div>
          </template>
        </el-table-column>

        <!-- 订单号 -->
        <el-table-column label="订单号" min-width="220" align="left">
          <template slot-scope="scope">
            <div class="order-numbers">
              <div class="out-trade-no">商户: {{ scope.row.outTradeNo }}</div>
              <div class="pay-id">三方: {{ scope.row.payId }}</div>
            </div>
          </template>
        </el-table-column>

        <!-- 金额 -->
        <el-table-column prop="totalPrice" label="金额" width="140" sortable="custom" align="right">
          <template slot-scope="scope">
            <div class="amount">支付金额：¥{{ scope.row.totalPrice }}</div>
            <div class="fee">手续费：¥{{ scope.row.handling_fee ||'0.00'}}</div>
          </template>
        </el-table-column>

        <!-- 支付方式 -->
        <el-table-column prop="pay_type_text" label="支付方式" width="120" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="getPayTypeTagType(scope.row.paymentType)">
              {{ scope.row.pay_type_text }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column prop="status_text" label="状态" width="120" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="getStatusTagType(scope.row.status)">
              {{ scope.row.status_text }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 时间信息 -->
        <el-table-column label="时间信息" min-width="180" align="left">
          <template slot-scope="scope">
            <div class="time-info">
              <div class="pay-time" v-if="scope.row.pay_time">支付: {{ scope.row.pay_time }}</div>
              <div class="create-time">下单: {{ scope.row.created_at }}</div>
            </div>
          </template>
        </el-table-column>

        <!-- IP信息 -->
        <el-table-column label="IP信息" min-width="160" align="left">
          <template slot-scope="scope">
            <div class="ip-info">
              <div class="user-ip">用户: {{ scope.row.user_ip }}</div>
              <div class="terminal-ip">下单: {{ scope.row.terminalIp }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)">查看详情</el-button>
            <el-button type="text" @click="queryOrder(scope.row, 'order')">查支付</el-button>
            <el-button type="text" @click="queryOrder(scope.row, 'cancel')">查退款</el-button>
            <el-button type="text" @click="handleRefund(scope.row)" :disabled="scope.row.status_text !== '已付款'">退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="pagination.page"
          :page-size="pagination.limit" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </el-card>

    <el-dialog title="订单详情" :visible.sync="detailDialogVisible" width="560px">
      <el-form label-width="120px">
        <el-form-item label="id">
          <el-input v-model="detail.id" disabled />
        </el-form-item>
        <el-form-item label="商户单号">
          <el-input v-model="detail.order_sn" disabled />
        </el-form-item>
        <el-form-item label="三方单号">
          <el-input v-model="detail.third_sn" disabled />
        </el-form-item>
        <el-form-item label="金额">
          <el-input v-model="detail.money" disabled />
        </el-form-item>

        <el-form-item label="支付方式">
          <el-input v-model="detail.pay_type_text" disabled />
        </el-form-item>
        <el-form-item label="状态">
          <el-input v-model="detail.status_text" disabled />
        </el-form-item>
        <el-form-item label="下单时间">
          <el-input v-model="detail.created_at" disabled />
        </el-form-item>
        <el-form-item label="下单IP">
          <el-input v-model="detail.order_ip" disabled />
        </el-form-item>
        <el-form-item label="用户IP">
          <el-input v-model="detail.user_ip" disabled />
        </el-form-item>
        <el-form-item label="回调地址">
          <el-input v-model="detail.notice_url" disabled />
        </el-form-item>
        <el-form-item label="同步返回地址">
          <el-input v-model="detail.back_url" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    
    <!-- 退款对话框 -->
    <el-dialog title="退款操作" :visible.sync="refundDialogVisible" width="400px">
      <el-form label-width="100px">
        <el-form-item label="退款原因" required>
          <el-input type="textarea" v-model="refundReason" placeholder="请输入退款原因" rows="3" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="refundDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmRefund">确认退款</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        admin_id: "",
        keyword: "",
        orderId: "",
        status: "",
        paymentType: "",
        user_ip: "",
        terminalIp: "",
        subMerchantId: "",
        dateRange: [],
        mid: ""
      },
      sort: {
        field: "id",
        order: "desc"
      },
      // 防抖计时器
      searchTimer: null,
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      orders: [],
      detailDialogVisible: false,
      detail: {},
      selectedIds: [],
      stats: {
        total: 0,
        status: [],
        pay_type: [],
        total_money: 0,
        status_money: [],
        pay_type_money: []
      },
      loading: {
        list: false,
        detail: false,
        delete: false,
        refund: false
      },
      other: {
        merchants:[]
      },
      refundDialogVisible: false,
      refundReason: '',
      currentRefundOrder: null
    };
  },
  computed: {
    // 支付状态统计
    statusStats() {
      const map = this.buildStatsMap(this.stats.status, "status");
      return [
        { label: "待付款", value: map.pending || 0 },
        { label: "已付款", value: map.paid || 0 },
        { label: "退款中", value: map.refunding || 0 },
        { label: "已退款", value: map.refunded || 0 }
      ];
    },
    // 支付方式统计
    payTypeStats() {
      const map = this.buildStatsMap(this.stats.pay_type, "paymentType");
      return [
        { label: "微信支付", value: map.wechat || 0 },
        { label: "支付宝支付", value: map.alipay || 0 },
        { label: "微信公众号", value: map.wechat_jsapi || 0 },
        { label: "微信扫码支付", value: map.wechat_scan || 0 },
        { label: "支付宝扫码支付", value: map.alipay_scan || 0 }
      ];
    },
    // 金额总计
    totalMoney() {
      return this.formatMoney(this.stats.total_money || 0);
    },
    // 状态金额统计
    statusMoneyStats() {
      const map = this.buildStatsMap(this.stats.status_money, "status");
      return [
        { label: "待付款", value: this.formatMoney(map.pending || 0) },
        { label: "已付款", value: this.formatMoney(map.paid || 0) },
        { label: "退款中", value: this.formatMoney(map.refunding || 0) },
        { label: "已退款", value: this.formatMoney(map.refunded || 0) }
      ];
    },
    // 支付方式金额统计
    payTypeMoneyStats() {
      const map = this.buildStatsMap(this.stats.pay_type_money, "paymentType");
      return [
        { label: "微信支付", value: this.formatMoney(map.wechat || 0) },
        { label: "支付宝支付", value: this.formatMoney(map.alipay || 0) },
        { label: "微信公众号", value: this.formatMoney(map.wechat_jsapi || 0) },
        { label: "微信扫码支付", value: this.formatMoney(map.wechat_scan || 0) },
        { label: "支付宝扫码支付", value: this.formatMoney(map.alipay_scan || 0) }
      ];
    },
    // 总数量
    totalCount() {
      return Number(this.stats.total || 0);
    }
  },
  // 页面挂载完成
  mounted() {},
  // 页面创建完成
  created() {
    // 初始化拉取列表
    this.getOrders();
    this.getOther();
  },
  // 组件销毁前
  beforeDestroy() {
    // 清除定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    // 获取订单列表
    getOrders() {
      this.loading.list = true;
      const dateRange = Array.isArray(this.filters.dateRange) ? this.filters.dateRange : [];
      const startTime = dateRange[0] || "";
      const endTime = dateRange[1] || "";
      const filterQuery = this.buildQuery({
        admin_id: this.filters.admin_id,
        orderId: this.filters.orderId,
        keyword: this.filters.keyword,
        status: this.filters.status,
        paymentType: this.filters.paymentType,
        user_ip: this.filters.user_ip,
        terminalIp: this.filters.terminalIp,
        subMerchantId: this.filters.subMerchantId,
        start_time: startTime,
        end_time: endTime,
        mid: this.filters.mid
      });
      const query = this.buildQuery({
        page: this.pagination.page,
        limit: this.pagination.limit,
        admin_id: this.filters.admin_id,
        orderId: this.filters.orderId,
        keyword: this.filters.keyword,
        status: this.filters.status,
        paymentType: this.filters.paymentType,
        user_ip: this.filters.user_ip,
        terminalIp: this.filters.terminalIp,
        subMerchantId: this.filters.subMerchantId,
        start_time: startTime,
        end_time: endTime,
        sort_field: this.sort.field,
        sort_order: this.sort.order,
        mid: this.filters.mid
      });
      this.$http_get(`/admin/order/list?${query}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          this.orders = this.mapOrders(list);
          this.pagination.total = Number(res.data.total || 0);
          this.pagination.page = Number(res.data.current_page || this.pagination.page);
          this.pagination.limit = Number(res.data.per_page || this.pagination.limit);
        } else {
          this.$message.error(res.msg || '获取订单列表失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('获取订单列表失败:', err);
      }).finally(() => {
        this.loading.list = false;
      });
      this.getOrderStats(filterQuery);
    },
    // 获取订单统计
    getOrderStats(query) {
      this.$http_get(`/admin/order/stats?${query}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.stats.total = Number(res.data.total || 0);
          this.stats.status = Array.isArray(res.data.status) ? res.data.status : [];
          this.stats.pay_type = Array.isArray(res.data.pay_type) ? res.data.pay_type : [];
          this.stats.total_money = res.data.total_money || 0;
          this.stats.status_money = Array.isArray(res.data.status_money) ? res.data.status_money : [];
          this.stats.pay_type_money = Array.isArray(res.data.pay_type_money) ? res.data.pay_type_money : [];
        } else {
          console.error('获取订单统计失败:', res);
        }
      }).catch(err => {
        console.error('获取订单统计失败:', err);
      });
    },
    getOther() {
      this.$http_get(`/admin/order/other`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.other = res.data || {};
        } else {
          console.error('获取失败:', res);
        }
      }).catch(err => {
        console.error('获取失败:', err);
      });
    },
    // 商户选择变化时的处理方法
    handleMerchantChange() {
      // 清除子商编选择
      this.filters.subMerchantId = '';
    },
    // 获取当前商户的子商编列表
    getSubMerchants() {
      if (!this.filters.mid) {
        return [];
      }
      
      // 查找当前选中的商户
      const merchant = this.other.merchants.find(m => m.id === parseInt(this.filters.mid));
      if (!merchant || !merchant.subMerchants) {
        return [];
      }
      
      return merchant.subMerchants;
    },
    // 拼接查询参数
    buildQuery(params) {
      return Object.keys(params)
        .filter(key => params[key] !== "" && params[key] !== null && params[key] !== undefined)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join("&");
    },
    // 映射接口数据到表格字段
    mapOrders(list) {
      return list.map(item => ({
        ...item,
        id: item.id,
        admin_id: item.admin_id,
        outTradeNo: item.outTradeNo,
        payId: item.payId,
        totalPrice: item.totalPrice,
        user_ip: item.user_ip,
        terminalIp: item.terminalIp,
        created_at: this.formatTime(item.created_at),
        pay_type_text: this.getPayTypeText(item.paymentType || item.pay_type),
        status_text: this.getStatusText(item.status)
      }));
    },
    // 获取状态文案
    getStatusText(value) {
      const map = {
        "0": "待付款",
        "1": "已付款",
        "2": "退款中",
        "3": "已退款",
      };
      return map[value] || value || "";
    },
    // 获取支付方式文案
    getPayTypeText(value) {
      const map = {
        wechat: "微信支付",
        alipay: "支付宝支付",
        wechat_jsapi: "微信公众号",
        wechat_scan: "微信扫码支付",
        alipay_scan: "支付宝扫码支付"
      };
      return map[value] || value || "";
    },
    // 获取支付方式标签类型
    getPayTypeTagType(value) {
      const map = {
        wechat: "success",
        alipay: "primary",
        wechat_jsapi: "warning",
        wechat_scan: "info",
        alipay_scan: "info"
      };
      return map[value] || "default";
    },
    // 获取状态标签类型
    getStatusTagType(value) {
      const map = {
        "0": "warning", // 待付款
        "1": "success", // 已付款
        "2": "info", // 退款中
        "3": "danger" // 已退款
      };
      return map[value] || "default";
    },
    // 生成统计映射
    buildStatsMap(list, key) {
      const map = {};
      list.forEach(item => {
        const valueKey = item.total !== undefined ? "total" : "count";
        let mapKey = item[key];
        if (key === "status") {
          mapKey = this.normalizeStatusKey(mapKey);
        }
        map[mapKey] = Number(item[valueKey] || 0);
      });
      return map;
    },
    // 统一状态键
    normalizeStatusKey(value) {
      const map = {
        "0": "pending",
        "1": "paid",
        "2": "refunding",
        "3": "refunded"
      };
      return map[value] || value;
    },
    // 格式化金额
    formatMoney(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return String(value || 0);
      }
      return num.toFixed(2);
    },
    // 格式化时间
    formatTime(value) {
      if (!value) {
        return "";
      }
      const numeric = Number(value);
      const dateValue = Number.isNaN(numeric) ? new Date(value) : new Date(numeric * 1000);
      if (Number.isNaN(dateValue.getTime())) {
        return String(value);
      }
      const year = dateValue.getFullYear();
      const month = String(dateValue.getMonth() + 1).padStart(2, "0");
      const day = String(dateValue.getDate()).padStart(2, "0");
      const hour = String(dateValue.getHours()).padStart(2, "0");
      const minute = String(dateValue.getMinutes()).padStart(2, "0");
      const second = String(dateValue.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    // 查询列表
    handleSearch() {
      this.pagination.page = 1;
      
      // 清除之前的计时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      
      // 设置新的计时器，300ms防抖
      this.searchTimer = setTimeout(() => {
        this.getOrders();
      }, 300);
    },
    // 选中行变化
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id);
    },
    // 删除已选
    confirmDelete() {
      if (!this.selectedIds.length) {
        this.$message.warning("请先选择订单");
        return;
      }
      this.$confirm("删除数据不可恢复！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading.delete = true;
        this.$http_post("/admin/order/delete", { ids: this.selectedIds }, 1).then(res => {
          if (res && res.code === 200) {
            this.$message.success('删除成功');
            this.selectedIds = [];
            if (this.orders.length === 1 && this.pagination.page > 1) {
              this.pagination.page -= 1;
            }
            this.getOrders();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        }).catch(err => {
          this.$message.error('网络错误');
          console.error('删除订单失败:', err);
        }).finally(() => {
          this.loading.delete = false;
        });
      }).catch(() => { });
    },
    // 重置筛选
    handleReset() {
      this.filters.admin_id = "";
      this.filters.orderId = "";
      this.filters.keyword = "";
      this.filters.status = "";
      this.filters.paymentType = "";
      this.filters.user_ip = "";
      this.filters.terminalIp = "";
      this.filters.subMerchantId = "";
      this.filters.dateRange = [];
      this.filters.mid = "";
      this.sort.field = "id";
      this.sort.order = "desc";
      this.pagination.page = 1;
      this.selectedIds = [];
      this.getOrders();
    },
    // 切换排序
    handleSortChange({ prop, order }) {
      const fieldMap = {
        id: "id",
        admin_id: "admin_id",
        outTradeNo: "outTradeNo",
        payId: "payId",
        totalPrice: "totalPrice",
        pay_type_text: "paymentType",
        status_text: "status",
        user_ip: "user_ip",
        terminalIp: "terminalIp",
        created_at: "created_at",
        mid: "mid"
      };
      this.sort.field = fieldMap[prop] || "id";
      if (order === "ascending") {
        this.sort.order = "asc";
      } else if (order === "descending") {
        this.sort.order = "desc";
      } else {
        this.sort.order = "desc";
      }
      this.pagination.page = 1;
      this.getOrders();
    },
    // 切换页码
    handlePageChange(page) {
      this.pagination.page = page;
      this.getOrders();
    },
    // 切换每页条数
    handleSizeChange(size) {
      this.pagination.limit = size;
      this.pagination.page = 1;
      this.getOrders();
    },
    // 打开详情弹窗
    openDetail(row) {
      this.loading.detail = true;
      this.$http_get(`/admin/order/detail?id=${row.id}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.detail = {
            ...res.data,
            id: res.data.id,
            order_sn: res.data.outTradeNo || res.data.order_sn,
            third_sn: res.data.payId || res.data.third_sn,
            money: res.data.totalPrice || res.data.money,
            admin_id: res.data.admin_id,
            pay_type: res.data.paymentType || res.data.pay_type,
            status: res.data.status,
            user_ip: res.data.user_ip,
            order_ip: res.data.terminalIp || res.data.order_ip,
            notice_url: res.data.notice_url,
            back_url: res.data.back_url,
            created_at: this.formatTime(res.data.created_at),
            pay_type_text: this.getPayTypeText(res.data.paymentType || res.data.pay_type),
            status_text: this.getStatusText(res.data.status)
          };
          this.detailDialogVisible = true;
        } else {
          this.$message.error(res.msg || '获取订单详情失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('获取订单详情失败:', err);
      }).finally(() => {
        this.loading.detail = false;
      });
    },
    // 处理退款
    handleRefund(row) {
      this.currentRefundOrder = row;
      this.refundReason = '';
      this.refundDialogVisible = true;
    },
    // 确认退款
    confirmRefund() {
      // if (!this.refundReason.trim()) {
      //   this.$message.warning('请输入退款原因');
      //   return;
      // }
      
      if (!this.currentRefundOrder) {
        this.$message.error('退款订单信息丢失');
        return;
      }
      
      this.loading.refund = true;
      this.$http_post('/admin/order/cancelOrder', {
        id: this.currentRefundOrder.id,
        reason: this.refundReason.trim()
      }, 1).then(res => {
        if (res && res.code === 200) {
          this.refundDialogVisible = false;
          this.getOrders();
        } 
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('退款失败:', err);
      }).finally(() => {
        this.loading.refund = false;
      });
    },
    // 查询订单
    queryOrder(row, type) {
      this.loading.detail = true;
      this.$http_get(`/admin/order/queryOrder?id=${row.id}&type=${type}`, 1).then(res => {
        if (res && res.code === 200) {
          console.log('查询订单结果:', res.data);
          // 重新加载订单列表以更新状态
          this.getOrders();
        } 
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('查询订单失败:', err);
      }).finally(() => {
        this.loading.detail = false;
      });
    }
  }
};
</script>

<style>
.table-filters {
  margin-bottom: 12px;
}

.order-summary {
  display: grid;
  grid-template-columns: 160px 1fr 1fr;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
}

.order-summary-money {
  margin-top: 8px;
}

.order-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.summary-label {
  font-size: 12px;
  color: #909399;
}

.summary-value {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-top: 6px;
}

.summary-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.summary-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.table-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
